import { render, staticRenderFns } from "./BookmarkButton.vue?vue&type=template&id=7700241a"
import script from "./BookmarkButton.vue?vue&type=script&lang=js"
export * from "./BookmarkButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports